<header>
    <h1 mat-dialog-title>{{(Group$ | async)?.Name + ' Mitglieder zuweisen'}}</h1>
    <span class="spacer"></span>
    <button app-round-button (click)="openEditGroupPopUp()"><fa-icon icon="pencil-alt"></fa-icon></button>
    <button app-round-button Color="red" Inverted (click)="openDeletePopup()"><fa-icon icon="trash"></fa-icon></button>
</header>
<app-multi-select-table
    mat-dialog-content
    *ngIf="ContentResolved$ | async; else loading"
    [TableData]="FilteredTableData$ | async"
    [TableDataConfig]="TableDataConfig"
    [Selected]="SelectedMembers$ | async"
    (RemoveSelected)="RemoveSelected($event)"
    Headline=""
    SearchPlaceHolder="nach Mitarbeitern und Kontakten suchen"
    SelectedHeadline="zugewiesene Mitglieder"
    EmptyText="keine Mitglieder vorhanden"
    (SearchStringChange)="SearchString.next($event)"
>

    <div class="filter-wrapper">
        <button
            app-round-button
            Inverted
            [matBadge]="FilterAmount$ | async"
            matTooltip="Filter"
            [matBadgeOverlap]="true"
            [matBadgeHidden]="!(FilterAmount$ | async)"
            (click)="filter.Open()"
        >
            <fa-icon icon="filter"></fa-icon>
        </button>
        <app-filter-card UnlimitedHeight #filter [Settings]="FilterSettings" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)"></app-filter-card>
    </div>
</app-multi-select-table>

<mat-dialog-actions>
    <div class="cancel-button-wrapper">
        <button app-button mat-dialog-close="" Inverted [IsLoading]="LS.IsLoading$ | async">Abbrechen</button>
    </div>
    <button app-button (click)="Submit()" [IsLoading]="LS.IsLoading$ | async" Color="green">Speichern</button>
</mat-dialog-actions>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
